import { useAppSelector } from 'store/store';
import { ROLE_TENANT_DIRECTOR } from 'shared/permissions/roles';

export function useIsDirector(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.includes(ROLE_TENANT_DIRECTOR) ?? false;
}
